import { API } from "app/api";

export const getAssignmentListApi = (data: Record<string, unknown>) => {
    return API.post('/api/classroom/getGroupAssignmentList', data);
}

export const getMemberInQuestApi = (data: Record<string, unknown>) => {
    return API.post('/api/discussiongroups/getMembersInQuestList', data);
}